module.exports = __webpack_public_path__ + "static/media/nestje5.509ba566.webp";